// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1kaIQ","question":"Question_question__D0wpy","description":"Question_description__RtDj6"};